import loader from '@assets/gifs/load.gif';
import { Typography } from '@components/style';
import { useWindowSizeNoTimeout } from '@hooks/UseWindowSizeNoTimeout';
import { theme } from '@styles/theme';
import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

interface LoaderProps {
  content?: string;
  coverModal?: boolean;
  padding?: string;
  zIndex?: number;
}

const Loader: FC<LoaderProps> = ({ content, coverModal = true, padding, zIndex }) => {
  const windowHeight = useWindowSizeNoTimeout()[1];
  const calculatedWindowHeight = Math.round(windowHeight / 3);
  const loaderPadding = `${calculatedWindowHeight}px 0 ${calculatedWindowHeight * 2}px 0`;

  return (
    <Wrapper
      data-testid='loader'
      coverModal={coverModal}
      padding={padding ?? loaderPadding}
      zIndex={zIndex}
    >
      <LoaderImage src={loader} alt='Fritz' />
      <Typography size={theme.typography.h2} marginLeft={5}>
        {content ? content : 'Loading...'}
      </Typography>
    </Wrapper>
  );
};

const fade = keyframes`
  to {
    opacity: 0;
  }
`;

const Wrapper = styled.div<LoaderProps>`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: ${(props) => (props.coverModal ? 'fixed' : 'relative')};
  background-color: ${(props) => (props.coverModal ? 'rgba(255, 255, 255, 0.8)' : 'transparent')};
  border-radius: ${(props) => (props.coverModal ? '6px' : '')};
  font-size: 30px;
  text-align: center;
  padding: ${(props) => props.padding};
  width: 100%;

  ${(props) =>
    props.zIndex
      ? `z-index: ${props.zIndex} !important;
    `
      : `z-index: 99;`}
`;

const LoaderImage = styled.img`
  height: 25px;
  animation: ${fade} 1s linear infinite alternate;
`;

export default Loader;
